// extracted by mini-css-extract-plugin
export default {"wrap":"cYggFAKo","title":"vTNJXG_W"};